<template>
  <nav class="navbar navbar-toggleable-md navbar-light bg-faded">
    <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <a class="navbar-brand" href="#">
      <img id="logo_img" src="/static/images/logo.png" width="200">
    </a>
    <div class="collapse navbar-collapse" id="navbarNav">

      <div class="navbar-nav ml-auto">


        <!--<router-link class="nav-link" to="/leads" v-show="hasPermission(13)" ><i class="fa fa-address-card" ></i> &nbsp;Leads</router-link>-->

        <li class="nav-item dropdown" v-show="hasPermission(12)">
          <a class="nav-link dropdown-toggle" href="http://example.com" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-file-text"></i> &nbsp;Quoting
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a target="_blank" href="https://clec.att.com/facilitiescheck/facilities_chk.cfm" class="nav-link" v-show="$canAccess(12, 31)" >
                <i class="fa fa-search"></i> &nbsp;AT&T Lookup</a>
              <router-link class="nav-link" to="/quotes/location-info" v-show="$canAccess(12, 32)"><i class="fa fa-search"></i> &nbsp;Location Info</router-link>
              <router-link class="nav-link" to="/quotes/telno-lookup" v-show="$canAccess(12, 33)"><i class="fa fa-search"></i> &nbsp;Telno Lookup</router-link>
          </div>
          </li>

        <router-link class="nav-link" to="/map" v-show="hasPermission(23)" ><i class="fa fa-map"></i> &nbsp;Map</router-link>

        <router-link class="nav-link" to="/agents" v-show="hasPermission(19)"><i class="fa fa-user"></i> &nbsp;Agents</router-link>

        <router-link class="nav-link" to="/leads" v-show="hasPermission(27)" ><i class="fa fa-user-circle-o"></i> &nbsp;Leads</router-link>

        <router-link class="nav-link" to="/account-details" v-show="hasPermission(8)" ><i class="fa fa-user-circle-o"></i> &nbsp;Accounts</router-link>

        <router-link class="nav-link" to="/dashboard" v-show="hasPermission(20)" ><i class="fa fa-bar-chart"></i> &nbsp;Dashboard</router-link>

        <li class="nav-item dropdown" v-show="hasPermission(19) || hasPermission(10) ">
          <a class="nav-link dropdown-toggle" href="http://example.com" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-gear"></i> &nbsp;Setup
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <router-link class="nav-link" to="/setup"  v-show="hasPermission(10)"><i class="fa fa-gear"></i> &nbsp;Setup</router-link>
            <router-link class="nav-link" to="/cashflow" v-show="hasPermission(26)" ><i class="fa fa-user-circle-o"></i> &nbsp;Cashflow</router-link>
            <router-link class="nav-link" to="/carriers" v-show="hasPermission(21)" ><i class="fa fa-bar-chart"></i> &nbsp;Carriers</router-link>
              <router-link class="nav-link" to="/products" v-show="$canAccess(21, 23)"><i class="fa fa-tag"></i> &nbsp;Products</router-link>
            <router-link class="nav-link" to="/carrier-serviceable-load" v-show="hasPermission(23)"><i class="fa fa-map-marker"></i> &nbsp;Serviceability Upload</router-link>
            <router-link class="nav-link" to="/commission-matches" v-show="$canAccess(24, 29)"><i class="fa fa-link"></i> &nbsp; Commissions</router-link>
            <router-link class="nav-link" to="/sales-team" v-show="hasPermission(9)"><i class="fa fa-users" ></i> &nbsp;Sales Team</router-link>
            <router-link class="nav-link" to="/audit"  v-show="hasPermission(14)"><i class="fa fa-check"></i> &nbsp;Audit</router-link>
            <router-link class="nav-link" to="/reports" v-show="hasPermission(18)"><i class="fa fa-pie-chart" ></i> &nbsp;Reports</router-link>
            <router-link class="nav-link" to="/utilities" v-show="hasPermission(11)"><i class="fa fa-wrench" ></i> &nbsp;Utilities</router-link>
          </div>
        </li>



        <router-link class="nav-link" to="/logout"><i class="fa fa-lock"></i> &nbsp;Logout</router-link>
        </div>
        <div class="navbar-nav">
           <span class="navbar-label"> Logged In As:</span>
          <auto-complete
              v-show="hasPermission(22)"
              placeholder="Masquerade"
              :list="agentNames"
              :selection="selectedAgent"
              @change="changeAgent"
              @input="fetchAgents"
              loose
          >
          </auto-complete>

      </div>
    </div>
  </nav>
</template>

<script type="text/babel">
    import AutoComplete from '../assets/Autocomplete.vue';
  export default{
    data(){
      return {
          agents:[],
          selection: null,
          loading :false
      }
    },
    computed:{
        agentNames(){
            if(!this.agents) return [];
            return this.agents.map(function(agent){
                return agent.name;
            })
        },
        selectedAgent(){
            return (this.selection != null)? this.selection : this.$store.getters.getUserData.userName;
        }
    },
    components:{
        AutoComplete
    },

    methods:{
        changeAgent(agent){
            this.selection = agent;
            this.loading = true;
            if(agent){
                var agent_id = this.agents.filter(function(u){
                    return u.name == agent;
                }).map(function(u){
                    return u.user_id;
                })[0];

                this.$send(this, 'userMasquerade',{
                    user_profile_id: agent_id
                }).then(r => {
                    this.selection = this.$store.getters.getUserData.userName;
                    window.location = '/account-details';
                });

            }

        },
        fetchAgents(search){
            this.selection = search;
            this.$send(this, 'userMasqueradeUsers',{
                search: {
                    name: search
                },
                columns: ['name']
            }).then(r => {
                this.agents = r.userMasqueradeUsers;
            });
        },
        hasPermission(id){

            if(!this.$store.getters.getUserRoles || !this.$store.getters.getUserRoles[id]) return false;
            var roleCat = this.$store.getters.getUserRoles[id];
            var state = false;
            for(var role_id in roleCat.rolesPermissions){
              if(!roleCat.rolesPermissions.hasOwnProperty(role_id)) continue;
              if(roleCat.rolesPermissions[role_id].state) state = true;
            }
            return state;
        }

    },
    props: []
  }

</script>

<style>
  .navbar {
    background: #ffffff;
    border-bottom: 1px solid #e2e2e2;
  }
  .navbar-toggleable-md .navbar-nav .nav-link:hover{
    background-color: #e3eaf1;
  }
  .navbar-toggleable-md .navbar-nav .nav-link.active{
    background-color: #e3eaf1;
  }
  .navbar-toggleable-md .navbar-nav .nav-link{
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 600;
      color: #325482;
      border-radius:2px;
      padding-top: 10px;

  }
  .navbar-toggleable-md .navbar-nav .nav-link i{
    color: #5e9cd3;
  }

  .navbar .input-group.multi-select {

      height: 40px;
  }
  
  .navbar-label{
      display: inline-block;
      width:150px;
      padding:12px;
      font-size: 10px;
      text-transform: uppercase;
      color: #545454;
      font-weight:bold;
  }



  @media (min-width: 1130px){
    .navbar-toggleable-md .navbar-nav .nav-link {
      padding-right: 1rem;
      padding-left: 1rem;
    }
  }

</style>



// WEBPACK FOOTER //
// Navigation.vue?4e6df33c